var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.label)?_c('span',{staticClass:"tag",class:_vm.color},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }